import { render, staticRenderFns } from "./MyProfileReadOnlyPage.vue?vue&type=template&id=ab6086f6"
import script from "./MyProfileReadOnlyPage.vue?vue&type=script&lang=js"
export * from "./MyProfileReadOnlyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports